const PATH_PAGES = [
	["/products", "products"],
	["/newProduct", "products"],
	["/updateProduct", "products"],
	["/allAvailableProducts", "products"],
	["/viewProduct", "products"],
	["/categories", "categories"],
	["/new-category", "categories"],
	["/brands", "brands"],
	["/new-brand", "brands"],
	["/brand-pages", "brand-pages"],
	["/new-arrivals", "new-arrivals"],
	["/tax-rates", "tax-rates"],
	["/rates", "rates"],
	["/size-charts", "size-charts"],
	["/salesorder", "sales-orders"],
	["/orders", "orders"],
	["/orderDetails", "orders"],
	["/pending-orders", "pending-orders"],
	["/quotes/zoho", "zoho-quotes"],
	["/quotes", "quotes"],
	["/invoices", "invoices"],
	["/returns", "returns"],
	["/samples", "sample-requests"],
	["/bargains", "bargains"],
	["/sourcing/categories", "sourcing-categories"],
	["/sourcing/requests", "sourcing-requests"],
	["/sourcing/backorders", "backorders"],
	["/sourcing/special-requests", "special-sourcing-requests"],
	["/tasks", "tasks"],
	["/finance-requests", "finance-requests"],
	["/vendors-withdrawals", "vendor-withdrawals"],
	["/sales-withdrawals", "sales-partner-withdrawals"],
	["/invoicing", "invoicing"],
	["/vendors", "vendors"],
	["/sales-partners", "sales-partners"],
	["/zoho-customers", "zoho-customers"],
	["/customers", "customers"],
	["/partners", "partners"],
	["/integrations", "integration"],
	["/integration", "integration"],
	["/notificationsmanager", "notifications-manager"],
	["/seo-settings", "seo-settings"],
	["/settings/roles", "roles-permissions"],
	["/viewUser", "roles-permissions"],
	["/roles", "roles-permissions"],
].sort((a, b) => b[0].length - a[0].length);

const normalize = (path) => {
	const clean = `/${String(path ?? "").split("?")[0].replace(/^\/+/, "")}`;
	return clean.length > 1 ? clean.replace(/\/+$/, "") : clean;
};

export const pageKeyForPath = (path) => {
	const target = normalize(path);
	if (target === "/") return "dashboard";
	const match = PATH_PAGES.find(
		([prefix]) => target === prefix || target.startsWith(`${prefix}/`)
	);
	return match ? match[1] : null;
};

export const hasPage = (access, key) =>
	Boolean(access?.full_access || access?.pageKeys?.has(key));

export const hasScope = (access, scope) =>
	Boolean(access?.full_access || access?.scopeNames?.has(scope));

export const canOpenPath = (access, path) => {
	if (!access) return true;
	const key = pageKeyForPath(path);
	return key === null || hasPage(access, key);
};

export const firstAllowedPath = (access) => {
	const page = access?.pages?.find((item) => item.path);
	return page ? page.path : "/settings";
};
